import { z } from 'zod'

import { FORM_MESSAGES_MAP } from '@/constants/formMessages.constants'

export const claimGoalSchema = z.object({
  amount: z.number({ invalid_type_error: FORM_MESSAGES_MAP.EMPTY }).min(0),
  goalStepId: z.string().nullable().optional(),
  isNegative: z.boolean(),
  note: z.string().optional(),
})
